import pinia from "@/stores/index.js";
import { defineStore } from "pinia";

const useCategoryStore = defineStore("category", {
  state: () => {
    return {
      categories: [],
    };
  },
});

export const storeCategory = useCategoryStore(pinia);
